import React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";
import { DownloadBtn } from "./CardContactStyles";

export const PageLink = ({ link }) => {
    const { t, i18n } = useTranslation();

    const open_link = () => {
        window.open(link, '_blank'); 
    };

    return (
        <div
            role="button"
            className="btn-robot-link center-block"
        >
            <DownloadBtn onClick={open_link}>
                <strong>
                    {t('library-overlays.cardContactPublisherBtn')}
                </strong>
            </DownloadBtn>
        </div>
    )
};